(function ($) {
    const newsletterPopup = $('.newsletter-popup');
    const newsletterPopupFormId = newsletterPopup.data('form-id');

    if (!sessionStorage.getItem("newsletter-popup-closed")) {
        newsletterPopup.addClass('visible');
    }

    newsletterPopup.find('.popup-trigger span').on('click', function () {
        newsletterPopup.toggleClass('active');
    });

    newsletterPopup.find('.close-newsletter-popup').on('click', function () {
        newsletterPopup.remove();
        sessionStorage.setItem("newsletter-popup-closed", "true");
    });

    $(document).on("gform_confirmation_loaded", function (e, form_id) {
        if (newsletterPopupFormId === form_id) {
            sessionStorage.setItem("newsletter-popup-closed", "true");
        }
    });
})(jQuery);